import { render, staticRenderFns } from "./inscription.vue?vue&type=template&id=f648ec36&scoped=true&"
var script = {}
import style0 from "./inscription.vue?vue&type=style&index=0&id=f648ec36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f648ec36",
  null
  
)

export default component.exports